import { cn } from '@/lib/utils'

/**
 * Parent segment buttons in workspace-scoped breadcrumbs (inherits `--ws-color` from `.ws-nav-section`).
 * No border/ring/shadow on hover — avoids layout shift; highlight is workspace-tinted background only.
 */
export const workspaceCrumbParentButtonClassName = cn(
  'max-w-[min(100%,12rem)] cursor-pointer truncate rounded-md px-2 py-0.5 text-left text-xs font-medium text-muted-foreground',
  'transition-[background-color,color] duration-150 ease-out',
  'hover:bg-[color-mix(in_srgb,var(--ws-color)_34%,hsl(var(--sidebar)))]',
  'hover:text-foreground',
  'dark:hover:bg-[color-mix(in_srgb,var(--ws-color)_42%,hsl(var(--sidebar)))]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color-mix(in_srgb,var(--ws-color)_50%,transparent)] focus-visible:ring-inset',
)
